import storage from 'store'
import { login, logout, getUserInfoByToken } from '@/api/login'
import { ACCESS_TOKEN, PERMISSION, ROLES, USER, MENUS, MENU_AUTHORITY } from '@/store/mutation-types'
import { getMyMenus } from '@/api/role'
import router from '@/router'

const user = {
  state: {
    token: '',
    name: '',
    welcome: '',
    avatar: '',
    roles: [],
    permissions: {},
    user: {},
    menu_authority: null,
    menus: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      storage.set(ACCESS_TOKEN, token, 24 * 60 * 60 * 1000)
    },
    SET_NAME: (state, { name, welcome }) => {
      state.name = name
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
      storage.set(ROLES, roles)
    },
    SET_PERMISSION: (state, permissions) => {
      state.permissions = permissions
      storage.set(PERMISSION, permissions)
    },
    SET_USER: (state, user) => {
      state.user = user
      storage.set(USER, user)
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
      storage.set(MENUS, menus)
    },
    SET_MENU_AUTHORITY: (state, data) => {
      state.menu_authority = data
      storage.set(MENU_AUTHORITY, data)
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then(response => {
            const { token = '', roles = [], permissions = {}, user = {} } = response.data
            // 设置token
            commit('SET_TOKEN', token)
            // 设置角色
            commit('SET_ROLES', roles)
            // 设置权限信息
            commit('SET_PERMISSION', permissions)
            // 设置用户信息
            commit('SET_USER', user)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // get user menu
    getMyMenus({ commit, state }, token) {
      return new Promise(async (resolve, reject) => {
        let slug = []
        const has_permissions = storage.get('permissions')
        if (has_permissions) {
          slug = has_permissions?.slug || []
        } else {
          // 所有接口权限 通过列表接口权限判断是否有菜单权限
          getMyMenus({ task_id: token || state.token }).then((response) => {
            slug = response.data?.permissions?.slug || []
          })
          .catch(err => {
            reject(err)
          })
        }
        let router_options = router.options.routes[1].children
        function getOption(arr) {
          arr.map(route_item => {
            if (route_item.meta?.permission.length > 0) {
              const has_permission = route_item.meta?.permission.some(item => slug.includes(item))
              route_item.hidden = !has_permission
              if (slug.includes('*' || 'opt:/all')) {
                route_item.hidden = false
              }
            } else {
              route_item.hidden = true
            }
            if (route_item.children && route_item.children.length) {
              getOption(route_item.children)
            }
            return route_item
          })
          return arr
        }
        // 权限判断hidden后的路由表
        router_options = getOption(router_options)
        commit('SET_MENUS', router_options)
        resolve(router_options)
      })
    },
    // 登出
    Logout({ commit, state }) {
      return new Promise(resolve => {
        logout(state.token)
          .then(() => {
            storage.clearAll()
            resolve()
          })
          .catch(() => {
            resolve()
          })
          .finally(() => {})
      })
    },
    // 通过token获取用户信息
    async getUserInfoByToken({ commit, state }, tokenData) {
      await commit('SET_TOKEN', tokenData)
      const { data } = await getUserInfoByToken()
      const { token = '', roles = [], permissions = {}, user = {} } = data
      commit('SET_TOKEN', token)
      commit('SET_ROLES', roles)
      commit('SET_PERMISSION', permissions)
      commit('SET_USER', user)
      return data
    }
  }
}

export default user
